import * as stylex from '@stylexjs/stylex';
import '@tokens/motion.stylex';
import { motion } from '@tokens/motion.stylex';

// Ported 1:1 from the prototype `.scrim` (dimmed, blurred overlay behind modals/drawers).
export const styles = {
  scrim: {
    kVAEAm: "xixxii4",
    kpwlN0: "x10a8y8t",
    kWkggS: "xcpsgoo",
    k6WDB: "x19z9ohp",
    kSiTet: "xg01cxk",
    k33iCy: "xlshs6z",
    kmkexE: "xex5m1k",
    kY2c9j: "xf5e64p",
    $$css: true
  },
  confirm: {
    kY2c9j: "x11uqc5h",
    $$css: true
  },
  show: {
    kSiTet: "x1hc1fzr",
    k33iCy: "xnpuxes",
    $$css: true
  }
};